module.exports = __webpack_public_path__ + "static/media/johana.b426db57.jpg";